<template>
<popup :showFlag="showFlag"
       @onShowpop="onShowpop">
  <div class='customized-bg'>
    <div v-if="params.width||params.height||params.max||params.min||params.ppi!=300" class='reset-button' @click="reset"><img class='customized-icon' src="./img/reset.png"/>重置</div>
    <div class='customized-title'>自定义规格</div>
    <div class='customized-container'>
      <div class='customized-text customized-text-word'>像素尺寸</div>
      <div class='customized-input-container'>
        <input @blur="upkeyboard" type="number" placeholder="宽" class="customized-input" @input='recordWidth($event)' :value="params.width"/>
      </div>
      <div class='customized-text'>×</div>
      <div class='customized-input-container'>
        <input @blur="upkeyboard" type="number" placeholder="高" class="customized-input" @input='recordHeight($event)' :value = "params.height" />
      </div>
      <div class='customized-text'>PX</div>
    </div>
    <div class='customized-container'>
      <div class='customized-text customized-text-word'>文件大小</div>
      <div class='customized-input-container'>
        <input @blur="upkeyboard" type="number" placeholder="最小" class="customized-input" @input='recordMin($event)' :value = "params.min"/>
      </div>
      <div class='customized-text'>~</div>
      <div class='customized-input-container'>
        <input @blur="upkeyboard" type="number" placeholder="最大" class="customized-input" @input='recordMax($event)' :value = "params.max" >
      </div>
      <div class='customized-text'>KB</div>
    </div>
    <div class='customized-container'>
      <div class='customized-text customized-text-word'>分辨率</div>
      <div class='customized-input-container'>
        <input @blur="upkeyboard" type="number" placeholder="300" class="customized-input" @input='recordPPI($event)' :value = "params.ppi"/>
      </div>
      <div class='customized-text'>DPI</div>
      <img class='customized-icon' src="./img/info.png" @click="showDPI"/>
    </div>
    <slot></slot>
  </div>
  <duicuo @onCancel="onCancel"
          @onOk="sumbit">
    <div class="errorTip">{{errorTip}}</div>
  </duicuo>
</popup>
</template>

<script>
import popup from '@/components/popup'
import duicuo from '@/components/duicuo/duicuo'
import { MessageBox } from 'mint-ui'
import { mapState, mapMutations } from 'vuex'
import { upkeyboard } from '@/utils/utils'
export default {
  name: 'autoSpec',
  props: {
    showFlag: {
      default: false,
      type: Boolean
    }
  },
  computed: {
    ...mapState(['makePhotoInfo', 'defaultColor'])
  },
  data () {
    return {
      errorTip: '',
      params: {
        width: '',
        height: '',
        max: '',
        min: '',
        ppi: 300
      }
    }
  },
  methods: {
    ...mapMutations(['setMakePhotoInfo']),
    onShowpop () {
      console.log('点击遮罩层不消失')
    },
    upkeyboard () {
      upkeyboard()
    },
    reset () {
      this.errorTip = ''
      this.params = {
        width: '',
        height: '',
        max: '',
        min: '',
        ppi: 300
      }
    },
    recordWidth (e) {
      this.params.width = e.target.value
    },
    recordHeight (e) {
      this.params.height = e.target.value
    },
    recordMax (e) {
      this.params.max = e.target.value
    },
    recordMin (e) {
      this.params.min = e.target.value
    },
    recordPPI (e) {
      this.params.ppi = e.target.value
    },
    showDPI () {
      MessageBox.alert('DPI(Dots Per Inch)是指印刷设备的分辨率，对于电子照片，DPI与PPI是等值的。无特殊要求的照片直接使用默认的300DPI即可', 'DPI是什么？')
    },
    onCancel () {
      this.reset()
      this.$emit('onCloseSpec')
    },
    sumbit () {
      const pdata = this.params
      if (!pdata.width) {
        this.errorTip = '照片宽度不能为空'
        return
      }
      if (!pdata.height) {
        this.errorTip = '照片高度不能为空'
        return
      }
      if (!(/^[1-9]\d*$/.test(+pdata.width))) {
        this.errorTip = '宽必须为数字'
        return
      }
      if (!(/^[1-9]\d*$/.test(+pdata.height))) {
        this.errorTip = '高必须为数字'
        return
      }
      if (pdata.width < 70 || pdata.width > 1200) {
        this.errorTip = '照片宽度必须在70~1200px'
        return
      }
      if (pdata.height < 100 || pdata.height > 1600) {
        this.errorTip = '照片高度必须在100~1600px'
        return
      }
      if (pdata.width / pdata.height > 1 || pdata.width / pdata.height < 0.5) {
        this.errorTip = '照片宽高比要在0.5~1'
        return
      }
      if (pdata.min) {
        if (+pdata.min === 0) {
          this.errorTip = '文件最小值不能为0'
          return
        }
        if (!(/^[1-9]\d*$/.test(+pdata.min))) {
          this.errorTip = '文件最小值必须为数字'
          return
        }
        if (pdata.min > 5120) {
          this.errorTip = '文件最小值不能超过5120KB'
          return
        }
      }
      if (!(/^[1-9]\d*$/.test(pdata.ppi))) {
        this.errorTip = 'ppi必须为数字'
        return
      }
      if (pdata.ppi > 600) {
        this.errorTip = 'ppi不能大于600'
        return
      }
      if (pdata.max) {
        if (+pdata.max === 0) {
          this.errorTip = '文件最大值不能为0'
          return
        }
        if (!(/^[1-9]\d*$/.test(+pdata.max))) {
          this.errorTip = '文件最大值必须为数字'
          return
        }
        if (pdata.max > 5120) {
          this.errorTip = '文件最大值不能超过5120KB'
          return
        }
      }
      if (pdata.min && pdata.max && +pdata.max < +pdata.min) {
        this.errorTip = '文件最大值不能小于最小值'
        return
      }
      console.log(pdata)
      const {
        width,
        height,
        max,
        min,
        ppi
      } = pdata
      const { makePhotoInfo } = this
      console.log(this.defaultColor)
      makePhotoInfo.spec_id = ''
      makePhotoInfo.file_size_max = max * 1024
      makePhotoInfo.file_size_min = min * 1024
      makePhotoInfo.ppi = ppi
      makePhotoInfo.width_px = width
      makePhotoInfo.height_px = height
      makePhotoInfo.specName = '自定义'
      makePhotoInfo.width_mm = 0
      makePhotoInfo.height_mm = 0
      makePhotoInfo.background_color = this.defaultColor
      makePhotoInfo.print = 0 // 自定义规格不能有冲印
      this.setMakePhotoInfo(makePhotoInfo)
      this.$emit('onGomakephoto')
      this.reset()
    }
  },
  components: {
    popup,
    duicuo
  }
}
</script>

<style scoped>
.customized-bg{
  background-color: #F7F7F7;
  border-top-left-radius: .32rem;
  border-top-right-radius: .32rem;
  padding:.54rem 0;
  box-shadow: 0 0 .4rem rgba(0,0,0,0.2);
  position: relative;
}
.reset-button{
  color: #233CFF;
  font-size:.26rem;
  position: absolute;
  top: .29rem;
  right: .29rem;
  padding:.15rem;
  display: flex;
  align-items: center;
}
.customized-title{
  font-size:.24rem;
  color: #C1C2C2;
  text-align: center;
}
.customized-container{
  display: flex;
  display: -webkit-flex;
  align-items: center;
  margin: .48rem;
}
.customized-container div{
  margin-right: .32rem
}
.customized-text{
  font-size:.28rem;
  font-weight:bold;
  color:rgba(42,41,46,1);
}
.customized-text-word{
  width: 1.2rem;
}
.customized-placeholder{
  color: #B3B3B7;
  font-size: .26rem;
}
.customized-input-container{
  border-radius:.12rem;
  border:.02rem solid rgba(255,103,99, 0);
  width:1.44rem;
  height:.64rem;
  background:#F5F7FA;
}
.focused-customized-input-container{
  border:.02rem solid rgba(255,103,99,1);
}
.customized-input{
  padding: 0;
  margin: 0;
  background:#adadae2e;
  border:none;
  width:1.44rem;
  height:.64rem;
  font-size: .26rem;
  text-align: center;
}
.customized-icon{
  width: .32rem;
  height: .32rem;
  border:.1rem solid transparent;
}
.operation-container{
  display: flex;
  align-items: center;
  justify-content: space-around;
  height:1.12rem;
  background:rgba(255,255,255,1);
  box-shadow:0px -.06rem .24rem 0px rgba(236,238,242,0.82);
  margin-top: .64rem;
}
.errorTip{
  width: 3.5rem;
  font-size:.22rem;
  text-align: center;
  color:rgba(255,103,99,1);
}
</style>
